import { useState, useLayoutEffect } from 'react';

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useLayoutEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const updateMatch = (e) => {
      return setMatches(e.matches);
    };

    media.addEventListener('change', updateMatch);
    return () => {
      media.removeEventListener('change', updateMatch);
    };
  }, [matches, query]);

  return matches;
};
